<nz-breadcrumb style="margin:16px 0;">
  <nz-breadcrumb-item *ngFor="let bc of breadcrumbs"  >
    <a [routerLink]="'/admin' + bc.url">
    {{bc.label}}
    </a>
  </nz-breadcrumb-item>
</nz-breadcrumb>
